import { Injectable } from '@angular/core';

export type AppCurrency = 'USD' | 'SYP';

const STORAGE_KEY = 'app_currency';

@Injectable({
    providedIn: 'root',
})
export class CurrencyService {

    get currentCurrency(): AppCurrency {
        if (typeof window === 'undefined') return 'USD';
        return (localStorage.getItem(STORAGE_KEY) as AppCurrency) || 'USD';
    }

    setCurrency(currency: AppCurrency): void {
        if (typeof window === 'undefined') return;
        if (currency === this.currentCurrency) return;
        localStorage.setItem(STORAGE_KEY, currency);
        window.location.reload();
    }
}
